import type { SavedRitual } from '../data/ingredients';
import styles from './Welcome.module.css';

interface WelcomeProps {
  saved: SavedRitual[];
  onBegin: () => void;
  onLoad: (id: string) => void;
  onDelete: (id: string) => void;
}

export function Welcome({ saved, onBegin, onLoad, onDelete }: WelcomeProps) {
  return (
    <section className={styles.welcome}>
      <span className={styles.ornament} aria-hidden="true">
        ❦
      </span>
      <h1 className={styles.heading}>the ritual forge</h1>
      <p className={styles.subtitle}>compose a small ceremony from chosen ingredients</p>
      <p className={styles.body}>
        choose an intention, a setting, an object, an opening, a posture, a duration,
        a closing gesture. seven small ingredients become a single instruction you
        can keep, print, try, or set aside.
      </p>
      <button type="button" className={styles.begin} onClick={onBegin}>
        begin
      </button>

      {saved.length > 0 && (
        <section className={styles.savedSection}>
          <h2 className={styles.savedHeading}>your rituals</h2>
          <ul className={styles.savedList}>
            {saved.map((r) => (
              <li key={r.id} className={styles.savedItem}>
                <button
                  type="button"
                  className={styles.savedTitleBtn}
                  onClick={() => onLoad(r.id)}
                >
                  {r.ritual.title || `a ritual for ${r.ritual.intent}`}
                </button>
                <button
                  type="button"
                  className={styles.deleteBtn}
                  onClick={() => {
                    if (confirm('delete this ritual?')) onDelete(r.id);
                  }}
                  aria-label="delete"
                >
                  ×
                </button>
              </li>
            ))}
          </ul>
        </section>
      )}
    </section>
  );
}
